export const drawerItemsMain = [
  {
    key: "CustomerOrderReport",
    title: "customerOrderScreen",
    routes: [
      {
        nav: "CustomerOrderReport",
        routeName: "CustomerOrderReport",
        title: "customerOrderScreen",
      },
    ],
  },
  {
    key: "KanbanPOCScreen",
    title: "kanbanPoc",
    routes: [
      {
        nav: "KanbanPOCScreen",
        routeName: "KanbanPOCScreen",
        title: "kanbanPocReport",
      },
    ],
  },
  {
    key: "CustomerIssueReport",
    title: "customerIssueScreen",
    routes: [
      {
        nav: "CustomerIssueReport",
        routeName: "CustomerIssueReport",
        title: "customerIssueReport",
      },
    ],
  },
];
